<template>
  <v-list>
    <d-file-item
      v-for="(file, key) in filesByState.completed"
      :key="key"
      :uid="key"
      :item="file" />

    <d-file-item
      v-for="(file, key) in filesByState.pending"
      :key="key"
      :uid="key"
      :item="file" />

    <d-file-item
      v-for="(file, key) in filesByState.downloading"
      :key="key"
      :uid="key"
      :item="file" />

    <d-file-item
      v-for="(file, key) in filesByState.canceled"
      :key="key"
      :uid="key"
      :item="file" />

    <d-file-item
      v-for="(file, key) in filesByState.error"
      :key="key"
      :uid="key"
      :item="file" />
  </v-list>
</template>

<script>
  /*
    Files order from top to bottom:
      completed
      pending
      uploading
      canceled
      error
  */
  import DFileItem from './DFileItem.vue'
  import FILE_STATES from '../file-states.js'

  export default {
    name: 'd-files-list',
    components: {'d-file-item': DFileItem},
    props: {
      filesByState: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        'FILE_STATES': FILE_STATES
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/plugins/uploader/components/DFilesList.vue